interface CeremonyViewportStyleParams {
    iframeViewportHeight: number | null;
    isKeyboardVisible: boolean;
    viewportHeight: number;
    viewportOffsetTop: number;
}

/**
 * Builds the ceremony shell custom properties for the current viewport.
 *
 * @param params viewport measurements of the iframe host and the visual viewport
 * @returns custom properties to apply on the ceremony container, or undefined when none are needed
 */
export const getCeremonyViewportStyle = ({
    iframeViewportHeight,
    isKeyboardVisible,
    viewportHeight,
    viewportOffsetTop
}: CeremonyViewportStyleParams): Record<string, string> | undefined => {
    const style: Record<string, string> = {};

    if (iframeViewportHeight !== null) {
        style['--viewport-height'] = `${iframeViewportHeight}px`;
    }

    if (isKeyboardVisible) {
        style['--visual-viewport-height'] = `${viewportHeight}px`;
        style['--visual-viewport-offset-top'] = `${viewportOffsetTop}px`;
    }

    return Object.keys(style).length === 0 ? undefined : style;
};

export default getCeremonyViewportStyle;
